// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2Ek8H","balanceDisclaimer":"posDashboard_balanceDisclaimer__2XLdx"};